

let globals = {
    controllers: new Map(),
    models: {
        classes: new Map(),
        instances: new Map()
    }
}

export default globals;